import React, {Component} from 'react'
import Axios from 'axios'
import ReactDOM from 'react-dom';
import ComplainHeader from '../../components/ComplainHeader/ComplainHeader'
import ComplainMessages from '../../components/ComplainMessages/ComplainMessages'
import FormMessage from '../../components/FormMessage/FormMessage'
import Login from '../../components/Login/Login'
import './Complain.css'

class Complain extends Component {
    constructor(){
        super()
        this.state = {
            id: window.location.hash.replace("#", ""),
            authenticated: localStorage.getItem('token'),
            config: {
                headers: {'Authorization': 'Bearer ' + localStorage.getItem('token')}
            }
        }
    }

    componentWillMount() {
        Axios.get('/api/complain/'+this.state.id, this.state.config).then(resComplain => {
            Axios.get('/api/messages/'+this.state.id, this.state.config).then(resMessages => {
                let content = 
                <div id="complain" className="complain">
                    <div className="detail">
                        <Login/>
                        <ComplainHeader complain={resComplain.data}/>
                        <ComplainMessages messages={resMessages.data}/>
                    </div>
                    <FormMessage id={this.state.id} status={resComplain.data.status} update={this.updateMessages} folio={resComplain.data.folio}/>
                </div>
                ReactDOM.render(content, document.getElementById('complain'))
            }).catch(err =>{
                //agregar modal error
                console.log(err)
            })
        }).catch(error => {
            if(error.response.status === 401){
                localStorage.clear()
            }
        })
    }

    updateMessages = (id) => {
        this.setState({id:id})
        this.componentWillMount()
    }

    render(){
        let content = !this.state.authenticated?
            <Login/> :
            <div class="complain" id="complain"></div>
        return content
    }
}

export default Complain



// WEBPACK FOOTER //
// ./src/views/Complain/Complain.js